import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { ethers } from 'ethers';
import { ChainId } from '@shared/utils/config/networks';
import withdrawWrapper from '@/hooks/QuotingEngineCalls/transfer/helpers/withdrawWrapper';
import { useSession } from '@/contexts/LitSessionProvider';
import validateSolAddress from '@/lib/misc/validateSolAddress';
export function useWithdrawQuote() {
  const {
    PKP
  } = useSession();
  const [params, setParams] = useState();
  const handleSetParams = (key, value) => {
    setParams(prev => {
      return Object.assign(Object.assign({}, prev), {
        [key]: value
      });
    });
  };
  const isEnabled = () => {
    if ((params === null || params === void 0 ? void 0 : params.cloudWallet) && (params === null || params === void 0 ? void 0 : params.tokenAddress) && (params === null || params === void 0 ? void 0 : params.network) && (params === null || params === void 0 ? void 0 : params.tokenAddress) && ((params === null || params === void 0 ? void 0 : params.network) == ChainId.SOLANA ? validateSolAddress(params === null || params === void 0 ? void 0 : params.receiver, true) : ethers.utils.isAddress(params === null || params === void 0 ? void 0 : params.receiver))) {
      return true;
    }
    return false;
  };
  const query = useQuery({
    queryKey: ['withdrawQuote', params],
    queryFn: async () => {
      if (!isEnabled()) {
        throw new Error('Invalid parameters');
      }
      const data = await withdrawWrapper(Object.assign(Object.assign({}, params), {
        PKP: Object.assign({}, PKP)
      }));
      return data;
    },
    enabled: isEnabled()
  });
  return Object.assign(Object.assign({}, query), {
    setParams,
    handleSetParams,
    params,
    enabled: isEnabled()
  });
}